import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { SiteContent } from '@/types'

import Head from 'next/head'
import { Poppins, Quicksand } from 'next/font/google'
import { Toaster } from 'sonner'
import { SiteContentProvider } from '@/lib/site-content'

const display = Poppins({
    subsets: ['latin', 'latin-ext'],
    weight: ['500', '600', '700', '800'],
    display: 'swap'
})

const body = Quicksand({
    subsets: ['latin', 'latin-ext'],
    weight: ['400', '500', '600', '700'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${body.style.fontFamily};--font-app-heading:${display.style.fontFamily}}`

interface PageProps {
    site?: SiteContent
}

const App: FC<AppProps<PageProps>> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=5' />
                <meta name='theme-color' content='#fff6e9' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <SiteContentProvider value={pageProps.site ?? null}>
                <Component {...pageProps} />
            </SiteContentProvider>

            <Toaster
                position='top-center'
                richColors
                closeButton
                toastOptions={{
                    classNames: {
                        toast: 'rounded-card font-body'
                    }
                }}
            />
        </div>
    )
}

export default App
